<div class="row d-flex text-center rm-section-tabs">
  @for (section of sections; track section) {
    <span
      class="col-sm section-item"
      (click)="app.RMSubmenu.setSection(section)"
      [ngClass]="{ 'section-active': app.RMSubmenu.section === section }"
      >
      {{ app.RMSubmenu.getSectionLabel(section) }}
    </span>
  }
</div>
